import { PayloadAction, SliceCaseReducers, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { BookingInterface, ExtraItemSliceInterface, extraItemBookingInterface, extraItemsInterface } from '../types/types';
import { newStateFromFlatBooking } from '../components/utils/stateHelper';
import { changeGunOptions, setBookingStateFromFlat } from './gunOptionSlice';
import { autofillDeliveryReturn, changeDeliveryOptions, resetDeliveryOptions, setDeliveryDate, setDeliveryType, setPlayRange, setRentalPoint, setReturnDate } from './deliverySlice';

export const extraItemsSlice = createSlice<ExtraItemSliceInterface, SliceCaseReducers<ExtraItemSliceInterface>>({
    name: 'extraItems',
    initialState: {
        items: [],
        freeDeliverySwitch: false
    },
    reducers: {
        setExtras: (state, action) => {
            const items: extraItemBookingInterface[] = action.payload.items;
            state.items = items;
        },
        /**
         * Add a specified number of 
         * 
         * @param \{ "type": name of extra, "quantity": number \}
         */
        setExtraQuantity: (state, action) => {
            const type = action.payload.type;
            const quantity = action.payload.quantity;

            // If the item is already in the array, update its quantity
            for (const item of state.items) {
                if (item.type === type) {
                    item.quantity = quantity;
                    return;
                }
            }

            // If this point is reached, the item was not in the array before
            // Now it must be added
            const newExtra: extraItemBookingInterface = {
                "type": type,
                "quantity": quantity
            }
            state.items.push(newExtra);
        },
        setFreeDeliverySwitch: (state, action) => {
            const bool = action.payload;
            state.freeDeliverySwitch = bool;
        },
        resetExtras: (state) => {
            state.items = [];
        }
    },
    extraReducers(builder) {
        builder.addCase(setBookingStateFromFlat, (state, action) => {
            const newState = newStateFromFlatBooking(state, action.payload);
            return newState as ExtraItemSliceInterface;
        })
        .addCase(changeGunOptions, (state, action) => {
            state.freeDeliverySwitch = false;
            state.items = extraItemsSlice.getInitialState().items;
        })
        .addCase(changeDeliveryOptions, (state, action) => {
            const change = action.payload;
            // If delivery options have changed, then reset extras because they
            // may not be available anymore
            if (
                change.playStart
                || change.playEnd
                || change.deliveryType
                || change.startDate
                || change.endDate
            ) {
                state.items = extraItemsSlice.getInitialState().items;
                return state;
            } else {
                return state;
            }
        })
        .addMatcher(isAnyOf(
            setPlayRange,
            setDeliveryType,
            setDeliveryDate,
            setReturnDate,
            autofillDeliveryReturn,
            setRentalPoint,
            resetDeliveryOptions
        ), (state, action) => {
            state.items = extraItemsSlice.getInitialState().items;
            return state;
        });
    },
});

export const { setExtras, setExtraQuantity, setFreeDeliverySwitch, resetExtras } = extraItemsSlice.actions;
export default extraItemsSlice.reducer;